import { render, staticRenderFns } from "./CampoTags.vue?vue&type=template&id=354148dd"
import script from "./CampoTags.vue?vue&type=script&lang=js"
export * from "./CampoTags.vue?vue&type=script&lang=js"
import style0 from "./CampoTags.vue?vue&type=style&index=0&id=354148dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports